import { CAPABILITIES } from "@constants/capabilities";

// Report QA is NOT a tab — it's a top-bar button in Report Builder that
// toggles the inline col-4 ReportQAPanel. The /report-qa route still exists
// for deep-links, but it's intentionally absent from the tab bar.
//
// `capability` gates tab visibility (access levels v1): a referrer only has
// ASSESSMENT_PREP, so they see just that tab.
export const CASE_TABS = [
  {
    id: "assessment-prep",
    label: "Assessment Prep",
    capability: CAPABILITIES.ASSESSMENT_PREP,
  },
  // "Request Documents" (referrer provider-request flow) is hidden for now —
  // not in use until the referrer portal ships (MDRS-157). Restore then.
  // {
  //   id: "request-documents",
  //   label: "Request Documents",
  //   capability: CAPABILITIES.PROVIDER_REQUESTS,
  // },
  {
    id: "assessment-scribe",
    label: "Assessment Scribe",
    capability: CAPABILITIES.ASSESSMENT_SCRIBE,
  },
  {
    id: "report-builder",
    label: "Report Builder",
    capability: CAPABILITIES.REPORT_BUILDER,
  },
] as const;
